var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsTdBase } from './_sds-td-base';
import styles from './sds-td.lit.scss';
import { isNil } from 'lodash-es';
import { ifDefined } from 'lit-html/directives/if-defined.js';
/**
 * Control that represents table data that is text,
 * it also has the capability to render a given image as prefix to the given text.
 *
 * @tag sds-td
 */
let SdsTd = (() => {
    var _SdsTd_imageSrc_accessor_storage, _SdsTd_icon_accessor_storage, _SdsTd_withIcon_accessor_storage, _SdsTd_levelNumbering_accessor_storage, _SdsTd_containerDiv_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-td')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTdBase;
    let _imageSrc_decorators;
    let _imageSrc_initializers = [];
    let _imageSrc_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _withIcon_decorators;
    let _withIcon_initializers = [];
    let _withIcon_extraInitializers = [];
    let _levelNumbering_decorators;
    let _levelNumbering_initializers = [];
    let _levelNumbering_extraInitializers = [];
    let _containerDiv_decorators;
    let _containerDiv_initializers = [];
    let _containerDiv_extraInitializers = [];
    var SdsTd = _classThis = class extends _classSuper {
        /**
         * @Deprecated attribute: Use the with-icon attribute instead and place the icon or image in the slot.
         *
         * If specified, this image is rendered before given text.
         * @attr
         */
        get imageSrc() { return __classPrivateFieldGet(this, _SdsTd_imageSrc_accessor_storage, "f"); }
        set imageSrc(value) { __classPrivateFieldSet(this, _SdsTd_imageSrc_accessor_storage, value, "f"); }
        /**
         * @Deprecated attribute: Use the with-icon attribute instead and place the icon or image in the slot.
         *
         * If specified, this icon is rendered before given text.
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsTd_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsTd_icon_accessor_storage, value, "f"); }
        /**
         * Indicates if an icon or image is used before the text.
         * @attr
         */
        get withIcon() { return __classPrivateFieldGet(this, _SdsTd_withIcon_accessor_storage, "f"); }
        set withIcon(value) { __classPrivateFieldSet(this, _SdsTd_withIcon_accessor_storage, value, "f"); }
        get levelNumbering() { return __classPrivateFieldGet(this, _SdsTd_levelNumbering_accessor_storage, "f"); }
        set levelNumbering(value) { __classPrivateFieldSet(this, _SdsTd_levelNumbering_accessor_storage, value, "f"); }
        get containerDiv() { return __classPrivateFieldGet(this, _SdsTd_containerDiv_accessor_storage, "f"); }
        set containerDiv(value) { __classPrivateFieldSet(this, _SdsTd_containerDiv_accessor_storage, value, "f"); }
        render() {
            return html `
            <div name="td-container" class="${this.getClasses()}">
                ${this.renderNumbering()}
                <slot></slot>
                ${this.renderImage()} ${this.renderIcon()} ${this.renderText()}
            </div>
        `;
        }
        getTextContainer() {
            return this.containerDiv;
        }
        getCustomClasses() {
            return {
                'sds-td--has-icon': this.withIcon || this.icon !== undefined || this.imageSrc !== undefined,
            };
        }
        renderImage() {
            if (this.imageSrc !== undefined) {
                return html ` <img part="sds-table-img" src="${this.imageSrc}" /> `;
            }
        }
        renderIcon() {
            if (this.icon !== undefined) {
                return html `
                <sds-icon part="sds-table-icon" size="24" name="${this.icon}"></sds-icon>
            `;
            }
        }
        renderNumbering() {
            if (!isNil(this.levelNumbering)) {
                return html ` <span class="sds-table-numbering">${this.levelNumbering}</span>`;
            }
        }
        renderText() {
            return this.value
                ? html `
                  ${this.ellipsis
                    ? html `<sds-clipped-text
                            basic
                            text="${this.value}"
                            lines="${ifDefined(this.lines ? this.lines : undefined)}"
                        ></sds-clipped-text>`
                    : html `${this.value}`}
              `
                : '';
        }
        constructor() {
            super(...arguments);
            _SdsTd_imageSrc_accessor_storage.set(this, __runInitializers(this, _imageSrc_initializers, undefined));
            _SdsTd_icon_accessor_storage.set(this, (__runInitializers(this, _imageSrc_extraInitializers), __runInitializers(this, _icon_initializers, undefined)));
            _SdsTd_withIcon_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _withIcon_initializers, void 0)));
            _SdsTd_levelNumbering_accessor_storage.set(this, (__runInitializers(this, _withIcon_extraInitializers), __runInitializers(this, _levelNumbering_initializers, null)));
            _SdsTd_containerDiv_accessor_storage.set(this, (__runInitializers(this, _levelNumbering_extraInitializers), __runInitializers(this, _containerDiv_initializers, void 0)));
            __runInitializers(this, _containerDiv_extraInitializers);
        }
    };
    _SdsTd_imageSrc_accessor_storage = new WeakMap();
    _SdsTd_icon_accessor_storage = new WeakMap();
    _SdsTd_withIcon_accessor_storage = new WeakMap();
    _SdsTd_levelNumbering_accessor_storage = new WeakMap();
    _SdsTd_containerDiv_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTd");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _imageSrc_decorators = [property({ type: String })];
        _icon_decorators = [property({ type: String })];
        _withIcon_decorators = [property({ type: Boolean, attribute: 'with-icon' })];
        _levelNumbering_decorators = [property({ type: String })];
        _containerDiv_decorators = [query('div[name="td-container"]')];
        __esDecorate(_classThis, null, _imageSrc_decorators, { kind: "accessor", name: "imageSrc", static: false, private: false, access: { has: obj => "imageSrc" in obj, get: obj => obj.imageSrc, set: (obj, value) => { obj.imageSrc = value; } }, metadata: _metadata }, _imageSrc_initializers, _imageSrc_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _withIcon_decorators, { kind: "accessor", name: "withIcon", static: false, private: false, access: { has: obj => "withIcon" in obj, get: obj => obj.withIcon, set: (obj, value) => { obj.withIcon = value; } }, metadata: _metadata }, _withIcon_initializers, _withIcon_extraInitializers);
        __esDecorate(_classThis, null, _levelNumbering_decorators, { kind: "accessor", name: "levelNumbering", static: false, private: false, access: { has: obj => "levelNumbering" in obj, get: obj => obj.levelNumbering, set: (obj, value) => { obj.levelNumbering = value; } }, metadata: _metadata }, _levelNumbering_initializers, _levelNumbering_extraInitializers);
        __esDecorate(_classThis, null, _containerDiv_decorators, { kind: "accessor", name: "containerDiv", static: false, private: false, access: { has: obj => "containerDiv" in obj, get: obj => obj.containerDiv, set: (obj, value) => { obj.containerDiv = value; } }, metadata: _metadata }, _containerDiv_initializers, _containerDiv_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTd = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTd = _classThis;
})();
export { SdsTd };
